import BannerPromotion from "./BannerPromotion";

export default BannerPromotion;
